<script setup>
useCustomMeta('top', '')
const breadCrumbList = getBreadCrumb()
</script>

<template>
  <NuxtLayout
    name="custom"
    :bread-crumb-list="breadCrumbList"
  >
    <div class="frame">
      <LivecamMap />
      <LivecamAreaList />
      <LivecamFeature target-key="focus_livecam" />
    </div>
  </NuxtLayout>
</template>

<style lang="scss" scoped>
.frame {
  display: flex;
  flex-direction: column;
  gap: 30px;
}
</style>
